import { createContext } from "react";
import type { SnackbarType } from "../components/Snackbar";

export interface SnackbarContextValue {
  showSnackbar: (
    message: string,
    type?: SnackbarType,
    duration?: number,
  ) => void;
}

export const SnackbarContext = createContext<SnackbarContextValue | null>(null);
